module.exports = __webpack_public_path__ + "media/2.377cd1b5.mp4";